<template>
  <div id="chartComponent">
    <div id="chartBox" ref="charBox"></div>
  </div>
</template>

<script>
import echarts from "echarts/lib/echarts";
// 引入折线图
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
import { energyDataType, dateType } from "@/utils/typeParam";

export default {
  name: "chartComponent",
  data() {
    return {
      typeUnit: ''
    };
  },
  props: {
    dataSource: Object,
    energyType: 0,
    dateType: 0,
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.charBox);
    this.initData();
  },
  methods: {
    //根据类型判断颜色
    getTypeName() {
      switch (this.energyType) {
        case energyDataType.temperature:
          this.$set(this, 'typeUnit', '(℃)');
          return "温度";
        case energyDataType.humidity:
          this.$set(this, 'typeUnit', '(%)');
          return "湿度";
        case energyDataType.co2:
          this.$set(this, 'typeUnit', '(ppm)');
          return "C02";
        case energyDataType.formaldehyde:
          this.$set(this, 'typeUnit', '(μg/m³)');
          return "甲烷";
        default:
          return "";
      }
    },
    //根据选择的时间类型设置不同的数据
    getDateTypeDataOption() {
      var nameStr = this.getTypeName();
      var series = [
        {
          type: "line",
          name: this.dateType == dateType.hourType ? nameStr : "最低" + nameStr,
          stack: '最低值',
          itemStyle: {
            normal: {
              color: this.dateType == dateType.hourType ? "#F07878" : "#4A9AF4" 
            }
          },
          areaStyle: {
            normal: {
              color: this.dateType == dateType.hourType ? "#F07878" : "#4A9AF4"
            }
          },
          data: this.dataSource.dataArr.data1
        }
      ];
      if (this.dateType != dateType.hourType) {
        series.push({
          type: "line",
          name: "最高" + nameStr,
          stack: "最高值",
          itemStyle: {
            normal: {
              color: "#F07878"
            }
          },
          areaStyle: {
            normal: {
              color: "#F07878"
            }
          },
          data: this.dataSource.dataArr.data2
        });
      }
      return series;
    },
    //获取数据最小最大值
    getMinAndMaxData() {
      var minValue = this.dataSource.dataArr.data1[0];
      var data1MaxValue = minValue;
      var data2MaxValue = this.dataSource.dataArr.data2[0];
      this.dataSource.dataArr.data1.forEach(value => {
        if (minValue >= value) {
          minValue = value;
        }
        if (data1MaxValue <= value) {
          data1MaxValue = value;
        }
      });
      this.dataSource.dataArr.data2.forEach(value => {
        if (data2MaxValue <= value) {
          data2MaxValue = value;
        }
      });
      if (data1MaxValue > data2MaxValue) {
        data2MaxValue = data1MaxValue;
      }
      return {
        minValue: minValue == 0 ? minValue : minValue - 5,
        maxValue: this.dateType == dateType.hourType ? data1MaxValue + 1 : data2MaxValue + 1
      };
    },
    initData() {
      var valueObjc = this.getMinAndMaxData();
      var series = this.getDateTypeDataOption();
      var option = {
        backgroundColor: "#FFF",
        title: {
          text: this.dataSource.title + " " + this.typeUnit,
          textStyle: {
            color: "#000",
            fontSize: "16"
          },
          bottom: 0,
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            },
            textStyle: {
              color: "#999"
            }
          }
        },
        grid: {
          show: true,
          borderWidth: 0,
          top: 10,
          bottom: "52",
          textStyle: {
            color: "#999"
          }
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#999"
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              interval: 0
            },
            data: this.dataSource.timeArr
          }
        ],
        yAxis: [
          {
            type: "value",
            min: valueObjc.minValue,
            max: valueObjc.maxValue,
            minInterval: 5,
            splitLine: {
              show: true //显示分割区域
            },
            axisLine: {
              lineStyle: {
                color: "#999"
              }
            },
            axisTick: {
              show: true //显示刻度
            },
            axisLabel: {
              interval: 0 //显示所有标签
            }
          }
        ],
        dataZoom: [
          {
            type: "inside",
            show: false,
            xAxisIndex: [0],
            height: 1,
            start: 1,
            end: 100
          }
        ],
        series: series
      };
      this.myChart.setOption(option);
    }
  }
};
</script>
<style scoped>
#chartComponent {
  width: 100%;
  height: 100%;
}
#chartBox {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/subComponents/lineChartComponent.vue